class TagFilter extends HTMLSelectElement {
  constructor() {
    super();

    this.addEventListener('change', this.onChange);
    this.beforeInit();
  }

  beforeInit() {
    const option = this.selectedOptions[0] || this.options[0];
    if (!option) return;

    const width = theme.getElementWidth(this, option.text);
    this.style.setProperty('--width', `${width}px`);
  }

  onChange() {
    window.location.href = this.value;
  }
}

customElements.define('tag-filter', TagFilter, { extends: 'select' });
